export const ORDER_COMPLETE_MESSAGES = {
  TITLE: {
    LOADING: '...',
    ORDER_COMPLETED: 'Order Completed!',
    FORECAST_SUBMITTED: 'Inventory Forecast submitted!',
    // FRH-745: a PayTo checkout against a not-yet-Active mandate holds the
    // order rather than charging it — this is the terminal message for that
    // redirect, distinct from the instant-charge ORDER_COMPLETED above.
    PAYTO_PENDING: 'Order Placed — Pending Bank Approval',
  },
  MESSAGE: {
    LOADING: '...',
    ORDER_PLACED: 'Thank you, your order has been placed.',
    FORECAST_SUBMITTED: 'Thank you, your forecast has been submitted to your clinical director for consideration.',
    PAYTO_PENDING: 'Thank you, your order has been placed. We\'re waiting for your bank to approve the PayTo payment — you\'ll be notified once it\'s confirmed.',
  },
  BUTTON: {
    LOADING: '...',
    VIEW_ORDER: 'View Order',
    VIEW_FORECASTS: 'View Forecasts',
  },
};

export const ORDER_COMPLETE_FORMATS = {
  ORDER_NUMBER: (orderNumber) => `Order # - ${orderNumber}`,
  FORECAST_NUMBER: (requestNumber) => `Forecast # - ${requestNumber}`,
};

